import React from 'react';

const VERDICT_COLORS = {
  GO:      { bg: 'rgba(8,153,129,0.13)',  border: 'rgba(8,153,129,0.45)',  color: '#089981' },
  CAUTION: { bg: 'rgba(224,155,0,0.13)',  border: 'rgba(224,155,0,0.45)',  color: '#d4920a' },
  BLOCK:   { bg: 'rgba(242,54,69,0.13)',  border: 'rgba(242,54,69,0.45)',  color: '#f23645' },
};

const VERDICT_LABEL = {
  GO:      'AI·GO',
  CAUTION: 'AI·WARN',
  BLOCK:   'AI·BLOCK',
};

export default function ClaudeVerdictBadge({ verdict, score, reasoning, size = 'sm' }) {
  if (!verdict) return null;
  const s = VERDICT_COLORS[verdict] || VERDICT_COLORS.GO;
  const label = VERDICT_LABEL[verdict] || `AI·${verdict}`;
  const fontSize = size === 'sm' ? 9 : 10;

  const tip = reasoning
    ? `Claude AI — ${verdict} (score ${score ?? '?'})\n${reasoning}`
    : `Claude AI — ${verdict} (score ${score ?? '?'})`;

  return (
    <span
      title={tip}
      style={{
        display: 'inline-block',
        fontSize,
        fontWeight: 700,
        padding: '1px 5px',
        borderRadius: 3,
        background: s.bg,
        border: `1px solid ${s.border}`,
        color: s.color,
        letterSpacing: '0.04em',
        cursor: 'help',
        fontFamily: 'Roboto Mono, monospace',
        flexShrink: 0,
      }}
    >
      {label}
    </span>
  );
}
